;(function() {

    let body = document.querySelector('body');
    let header = document.querySelector('.header');
    let mobileMenu = document.querySelector('.js-mobile-menu');

    let burgerBtn = header.querySelector('.js-burger-btn');
    if (mobileMenu) {
        mobileMenu.addEventListener('click', function () {
            toggleMobileMenu();
        });
    }
    if (burgerBtn) {
        burgerBtn.addEventListener('click', function () {
            toggleMobileMenu();
        });
    }

    function toggleMobileMenu() {
        header.classList.toggle('header_open-menu-mob');
        body.classList.toggle('open-menu');
    }

})();
